import { Badge, Box, Button, DataList, Grid, GridItem, HStack, Separator, Table, Text, useDisclosure } from "@chakra-ui/react";
import { UI } from "components";
import useStock from "hooks/useStock";
import { useState } from "react";
import Vouchers from "./vouchers";
import useStockReport from "hooks/useStockReport";

export default function Stock() {

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState(null)
    const list = useStock(page, term)
    const report = useStockReport()

    const vouchers = useDisclosure()

    const columns = [{ children: 'Produto' }, { children: 'Estoque', textAlign: 'right' }, { children: 'Reservado', textAlign: 'right' }, , { children: 'Disponível', textAlign: 'right' }]

    return (
        <>
        <Vouchers {...vouchers} />
        <UI.Header title="Estoque" />

        <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} alignItems="flex-start" gap={6}>
            
            <GridItem>
                <Text fontSize="sm" color="GrayText" children="Resumo do estoque:" mb={4} />

                <DataList.Root orientation="horizontal" gap={2} divideY="1px">
                    <DataList.Item>
                        <DataList.ItemLabel>No estoque:</DataList.ItemLabel>
                        <DataList.ItemValue>{report.data?.stock}</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Reservados:</DataList.ItemLabel>
                        <DataList.ItemValue>{report.data?.reserved}</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Em falta:</DataList.ItemLabel>
                        <DataList.ItemValue>{report.data?.empty}</DataList.ItemValue>
                    </DataList.Item>
                </DataList.Root>
            </GridItem>

            <GridItem>
                <Text fontSize="sm" color="GrayText" children="Vouchers disponíveis:" mb={4} />

                <DataList.Root orientation="horizontal" gap={2} divideY="1px">
                    <DataList.Item>
                        <DataList.ItemLabel>Plano Start Turbo:</DataList.ItemLabel>
                        <DataList.ItemValue>{report.data?.vouchers} disponíveis</DataList.ItemValue>
                    </DataList.Item>
                </DataList.Root>

                <Button w="100%" size="sm" my={2} colorPalette="purple" onClick={vouchers.onOpen}><UI.Icon name="store" /> Comprar Vouchers</Button>
                <Text fontSize="xs">Clique para abrir a loja e adquirir kits de adesão.</Text>
            </GridItem>

        </Grid>

        <Separator my={4} />

        <UI.Searchable onChange={setTerm} value={term} placeholder="Procurar pelo nome do produto..." />

        <UI.Table loading={list.isFetching} loadingText="Buscando produto no estoque..." columns={columns} data={list.data?.data} meta={list.data?.meta} onPageChange={value => setPage(value.page)} Row={Row} />
        </>
    )
}

const Row = ({ data }) => {
    return (
        <Table.Row>
            <Table.Cell fontSize="sm" fontWeight="bold" color="gray.fg">{data?.product?.name ?? data?.product_kit?.label}</Table.Cell>
            <Table.Cell textAlign="right" fontSize="sm" fontWeight="bold" color="teal.focusRing"><Badge colorPalette={data?.stock <= 1 ? 'red' : 'green'} children={`${data?.stock} no estoque`} /></Table.Cell>
            <Table.Cell textAlign="right" fontSize="sm" fontWeight="bold" color="red.focusRing"><Badge colorPalette={data?.reserved <= 0 ? null : 'orange'} children={`${data?.reserved} reservados`} /></Table.Cell>
            <Table.Cell textAlign="right" fontSize="sm" fontWeight="bold" color="green.focusRing"><Badge colorPalette={data?.available <= 0 ? 'red' : 'teal'} children={`${data?.available} na loja`} /></Table.Cell>
        </Table.Row>
    )
}